import React from 'react';
import './App.css';
import './Notebook.css';
import { PiDotsThreeVertical } from "react-icons/pi";
import NotebookLang from './NotebookLang.json';
import NotebookNewPopup from './NotebookNewPopup.js';
import NotebookEditPopup from './NotebookEditPopup.js';
import NotebookDeletePopup from './NotebookDeletePopup.js';
import NotebookDotsPopup from './NotebookDotsPopup.js';

import { useNavigate } from "react-router-dom";

class NotebookList extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			companyID: 0,
			notebookArray: null,
			notebookNewPopupYN: false,
			notebookEditPopupYN: false,
			notebookDeletePopupYN: false,
			notebookDotsPopupYN: false,
			mouseX: 0,
			mouseY: 0,
			dotsNotebookID: 0,
		}

		this.refreshData = this.refreshData.bind(this);
		this.setNotebookNewPopupYN = this.setNotebookNewPopupYN.bind(this);
		this.setNotebookEditPopupYN = this.setNotebookEditPopupYN.bind(this);
		this.setNotebookDeletePopupYN = this.setNotebookDeletePopupYN.bind(this);
		this.setNotebookDotsPopupYN = this.setNotebookDotsPopupYN.bind(this);
	}
		
	componentDidMount() {
		var companyID = this.props.companyID;
		this.serverGetNotebookList(companyID);
	}

	componentDidUpdate() {
		
		var companyID1 = this.state.companyID;
		var companyID2 = this.props.companyID;

		if (companyID1 === companyID2) {
			return;
		}
		
		this.serverGetNotebookList(companyID2);

		this.setState({
			companyID: companyID2,
		});
	}
	
	refreshData() {
		var companyID = this.state.companyID;
		this.serverGetNotebookList(companyID);
	}

	async serverGetNotebookList(companyID) {
		
		if (companyID <= 0) {
			return;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getnotebooklist?companyid=" + companyID;
		
		var notebookArray = null;
		
		try {
			var res = await fetch(url);
			notebookArray = await res.json();
		} catch (err) {
			console.error(err);
		}
		
		this.setState({
			notebookArray: notebookArray,
		});
	}
	
	setNotebookNewPopupYN(notebookNewPopupYN) {
		this.setState({
			notebookNewPopupYN: notebookNewPopupYN,
		});
	}

	setNotebookEditPopupYN(notebookEditPopupYN) {
		this.setState({
			notebookEditPopupYN: notebookEditPopupYN,
		});
	}

	setNotebookDeletePopupYN(notebookDeletePopupYN) {
		this.setState({
			notebookDeletePopupYN: notebookDeletePopupYN,
		});
	}
	
	setNotebookDotsPopupYN(notebookDotsPopupYN) {
		this.setState({
			notebookDotsPopupYN: notebookDotsPopupYN,
		});
	}
	
	onMouseMove(event) {
		var mouseX = event.clientX;
		var mouseY = event.clientY;
		if (this.state.notebookDotsPopupYN) {
			return;
		}
		this.setState({
			mouseX: mouseX,
			mouseY: mouseY,
		});
	}
	
	onClickNotebook(notebookID) {
		this.props.setSelectedNotebook(notebookID);
		var navigate = this.props.navigate;
  		navigate("/notebook");		
	}

	onClickDots(notebookID) {
		this.setState({dotsNotebookID: notebookID});
		this.setNotebookDotsPopupYN(true);
	}
	
	onClickNewNotebook() {
		this.setNotebookNewPopupYN(true);	
 	}
	
	renderOneNotebook(index, itemObj) {

		var userID = this.props.userID;

		var key = "notebook-" + index;
		var notebookID = itemObj.notebookID;
		var title = itemObj.title;
		var createdUserID = itemObj.createdUserID;
		var createdUnixTimeSec = itemObj.createdUnixTimeSec;
		var sources = itemObj.sources;

		var role = "reader";
		var displayDotsYN = false;
		if (createdUserID === this.props.userID) {
			role = "owner";
			displayDotsYN = true;
		}
		var roleString = this.props.getLang(NotebookLang, role);

		var createdDateString = this.props.getDateStringFromUnixTimeSec(createdUnixTimeSec);
	
		return (
			<tr key={key}>
				<td className="NotebookListTitleItem" onClick={() => this.onClickNotebook(notebookID)}>{title}</td>
				<td className="NotebookListSourcesItem">{sources}</td>
				<td className="NotebookListCreatedItem">{createdDateString}</td>
				<td className="NotebookListRoleItem">{roleString}</td>
				{displayDotsYN && (
					<td className="NotebookListDotsItem" onClick={() => this.onClickDots(notebookID)}>				  
						<PiDotsThreeVertical style={{ width: "25px", height: "20px" }} />
					</td>)}
			</tr>
		);
	}
	
	renderAllNotebooks() {

		var notebookArray = this.state.notebookArray;
		if (notebookArray.length === 0) {
			return (
				<div>{this.props.getLang(NotebookLang, "noNotebooksFound")}</div>
			);			
		}

		var i;
		var itemObj;
		var jsxCode;
		var jsxArray = [];

		for(i=0; i<notebookArray.length; i++) {
			itemObj = notebookArray[i];
			jsxCode = this.renderOneNotebook(i, itemObj);
			jsxArray.push(jsxCode);
		}
		
		return (
			<div style={{width: "95vw", textAlign: "center"}}>
				<table style={{margin: "0 auto"}}>
					<thead>
						<tr>
							<th className="NotebookListTitleHeader">{this.props.getLang(NotebookLang, "title")}</th>
							<th className="NotebookListSourcesHeader">{this.props.getLang(NotebookLang, "sources")}</th>
							<th className="NotebookListCreatedHeader">{this.props.getLang(NotebookLang, "created")}</th>
							<th className="NotebookListRoleHeader">{this.props.getLang(NotebookLang, "role")}</th>
							<th className="NotebookListDotsHeader"></th>
						</tr>
					</thead>
					<tbody>
						{jsxArray}
					</tbody>
				</table>
			</div>
		);
	}
	
	renderNotebookNewPopup() {
		return (
			<NotebookNewPopup
				renderPopupYN={this.state.notebookNewPopupYN}
				baseURLAPI={this.props.baseURLAPI}
				userID={this.props.userID}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				notebookAppUserType={this.props.notebookAppUserType}
				notebookID={this.props.notebookID}
				showToast={this.props.showToast}
				getLang={this.props.getLang}
				setNotebookNewPopupYN={this.setNotebookNewPopupYN}
				refreshData={this.refreshData}
			/>
		);		
	}
	
	renderNotebookEditPopup() {
		return (
			<NotebookEditPopup
				renderPopupYN={this.state.notebookEditPopupYN}
				baseURLAPI={this.props.baseURLAPI}
				userID={this.props.userID}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				notebookAppUserType={this.props.notebookAppUserType}
				notebookID={this.state.dotsNotebookID}
				showToast={this.props.showToast}
				getLang={this.props.getLang}
				serverGetNotebookData={this.props.serverGetNotebookData}
				setNotebookEditPopupYN={this.setNotebookEditPopupYN}
				refreshData={this.refreshData}
			/>
		);		
	}
	
	renderNotebookDeletePopup() {
		return (
			<NotebookDeletePopup
				renderPopupYN={this.state.notebookDeletePopupYN}
				baseURLAPI={this.props.baseURLAPI}
				userID={this.props.userID}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				notebookAppUserType={this.props.notebookAppUserType}
				notebookID={this.state.dotsNotebookID}
				showToast={this.props.showToast}
				getLang={this.props.getLang}
				serverGetNotebookData={this.props.serverGetNotebookData}
				setNotebookDeletePopupYN={this.setNotebookDeletePopupYN}
				refreshData={this.refreshData}
			/>
		);		
	}
	
	renderNotebookDotsPopup() {
		return (
			<NotebookDotsPopup
				renderPopupYN={this.state.notebookDotsPopupYN}
				positionX={this.state.mouseX}
				positionY={this.state.mouseY}
				baseURLAPI={this.props.baseURLAPI}
				userID={this.props.userID}
				fullName={this.props.fullName}
				companyID={this.props.companyID}
				notebookAppUserType={this.props.notebookAppUserType}
				notebookID={this.props.notebookID}
				showToast={this.props.showToast}
				getLang={this.props.getLang}
				setNotebookDotsPopupYN={this.setNotebookDotsPopupYN}
				setNotebookEditPopupYN={this.setNotebookEditPopupYN}
				setNotebookDeletePopupYN={this.setNotebookDeletePopupYN}
			/>
		);		
	}
	
	render() {
		
		//console.log("companyID = " + this.props.companyID);

		var notebookArray = this.state.notebookArray;
		if (notebookArray === null) {
			return;
		}
		
		return (
			<div onMouseMove={(event) => {this.onMouseMove(event)}}>
				{this.renderNotebookNewPopup()}
				{this.renderNotebookEditPopup()}
				{this.renderNotebookDeletePopup()}
				{this.renderNotebookDotsPopup()}
				<div style={{height: "20px"}}></div>
				<div className="NotebookListTopTitle">{this.props.getLang(NotebookLang, "notebookListTopTitle")}</div>
				<div style={{height: "20px"}}></div>
				{this.renderAllNotebooks()}
				<div style={{height: "20px"}}></div>
				<button className="ViewSaveButton" onClick={() => this.onClickNewNotebook()}>{this.props.getLang(NotebookLang, "newNotebook")}</button>
			</div>
		);
	}
}

export default function NotebookListFunction(props) {
	const navigate = useNavigate();
	return <NotebookList {...props} navigate={navigate} />;
}

